// extracted by mini-css-extract-plugin
module.exports = {"NavItems":"Navigationitems_NavItems__2l9fs","name":"Navigationitems_name__2Ig9a","navColor":"Navigationitems_navColor__3iE_H"};